import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is the 5K a timed race?",
    a: "Yes. The 5K is a chip-timed event on a certified 3.13-mile course, with live results and age-group awards. If you prefer a relaxed pace, the 1 Mile Fun Walk is untimed.",
  },
  {
    q: "How does team registration work?",
    a: "Register as a Team of 5 for $312.49 or a Team of 10 for $625 — a savings of over 37% versus individual 5K entries. Team members can mix and match the timed run and the fun walk, and you get a dedicated team check-in lane on race morning.",
  },
  {
    q: "Where does my registration money go?",
    a: "Net proceeds go directly to Hope Restored Missions to expand capital resources and transitional housing for individuals and families in crisis, in recognition of National Hunger & Homelessness Awareness Week.",
  },
  {
    q: "Are kids, strollers, or pets welcome?",
    a: "Yes — the 1 Mile Fun Walk is all-ages and stroller friendly, and leashed pets are welcome. Children running the timed 5K must be registered participants.",
  },
  {
    q: "What happens if it rains?",
    a: "2Run4Hope is a rain-or-shine event. In the case of severe weather, updates will be emailed to all registered participants through Bloomerang.",
  },
  {
    q: "What is the refund policy?",
    a: "Refunds are not allowed for this race. Every registration is a donation toward transitional housing for families in crisis — thank you for your understanding and support.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-4 md:px-8 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.3em] text-hope-green">
            Good To Know
          </p>
          <h2
            data-testid="faq-heading"
            className="font-heading text-4xl font-black leading-[1.05] tracking-tighter text-hope-ink sm:text-5xl"
          >
            Questions,
            <br />
            Answered<span className="text-hope-red">.</span>
          </h2>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-zinc-600">
            Still curious about something? Send us a message below and the Hope
            Restored Missions team will get back to you.
          </p>
        </Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-heading text-lg font-bold text-hope-ink hover:text-hope-green md:text-xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-base leading-relaxed text-zinc-600"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
